import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import QuestionMark from '../../../../Components/Adornments/QuestionMark';
import TextInput from '../../../../Components/Inputs/TextInput';
import { InvoiceHelpType } from '../../../../Enums/invoices';
import { joinNames } from '../../../../Utils/Format/Names';

const InvoiceQuestionChallenge = props => {
  const {
    id,
    description,
    label,
    register,
    loading,
    setInvoiceHelp,
    metadata,
    formHelpers
  } = props;

  const classes = useStyles();

  const invoiceMonths = useMemo(() => {
    if (
      !metadata ||
      !metadata.detailInvoices ||
      metadata.detailInvoices.length === 0
    ) {
      return '';
    }

    const months = metadata.detailInvoices.map(
      detail => `${detail.monthLiteral} ${detail.year}`
    );

    return joinNames(months, ', ', ' o ');
  }, [metadata]);

  return (
    <>
      <div key={id} className={classes.questionContainer}>
        <Grid container direction="row">
          <Grid item xs={12} sm={6} className={classes.questionText}>
            <Typography>
              {description}{' '}
              {invoiceMonths && (
                <span className={classes.month}>{invoiceMonths}</span>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              inputRef={register}
              name={formHelpers.getFieldPath(id, 'value')}
              autoFocus
              fullWidth
              disabled={loading}
              label={label}
              required={true}
              error={Boolean(formHelpers.getFieldError(id, 'value'))}
              helperText={formHelpers.getFieldErrorMessage(id, 'value')}
              InputProps={{
                endAdornment: (
                  <QuestionMark
                    onClick={() => setInvoiceHelp(InvoiceHelpType.Invoice)}
                  />
                ),
                inputProps: {
                  type: 'number',
                  inputMode: 'numeric'
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  sectionText: {
    margin: theme.spacing(2, 0, 3, 0)
  },
  questionContainer: {
    marginBottom: theme.spacing()
  },
  questionText: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(0.5)
  },
  month: {
    fontWeight: 500
  }
}));

export default InvoiceQuestionChallenge;
